export const twoDp = (value: string | number) => {
	const valToString = value?.toString();
	let val = parseFloat(valToString).toFixed(2);
	return val;
};
